<h2 mat-dialog-title id="dialog-title">
  {{
    create
      ? ('BackOffice.ManageContracts.ContractLimit.AddLimit' | translate: locale.language)
      : ('BackOffice.ManageContracts.ContractLimit.EditLimit' | translate: locale.language)
  }}
</h2>

<mat-dialog-content>
  <form [formGroup]="limitForm" aria-labelledby="dialog-title">
    <div class="form-grid">
      <!-- Category -->
      <mat-form-field appearance="outline" class="full-width" style="margin-bottom: -1.5rem">
        <mat-label>
          {{ 'BackOffice.ManageContracts.ContractLimit.Category' | translate: locale.language }}
        </mat-label>
        <mat-select formControlName="category" aria-label="Select category" [required]="true">
          @for (category of categories; track category.id) {
            <mat-option [value]="category.id">
              {{ category.value }}
            </mat-option>
          }
        </mat-select>
        @if (limitForm.get('category')?.hasError('required')) {
          <mat-error>Category is required</mat-error>
        }
      </mat-form-field>

      <div class="form-field-container">
        <div id="code-label" class="field-label">
          {{ 'BackOffice.ManageContracts.ContractLimit.Code' | translate: locale.language }}
          <span class="required-indicator" aria-label="required">*</span>
        </div>
        <mat-chip-listbox
          aria-labelledby="code-label"
          [multiple]="false"
          [hideSingleSelectionIndicator]="false"
          class="code-chips">
          @for (code of codes; track code.id) {
            <mat-chip-option
              [selected]="isCodeSelected(code.id)"
              (click)="toggleCode(code.id)"
              [attr.aria-label]="'Select ' + code.value"
              (keydown.enter)="$event ? toggleCode(code.id) : null">
              {{ code.value }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
        @if (limitForm.get('code')?.hasError('required') && limitForm.get('code')?.touched) {
          <mat-error class="field-error">At least one code is required</mat-error>
        }
      </div>

      <!-- Limit -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>
          {{ 'BackOffice.ManageContracts.ContractLimit.Limit' | translate: locale.language }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="limitation"
          [required]="true"
          min="0"
          aria-label="Enter limit value"
          mask="separator.0"
          thousandSeparator=","
          autocomplete="off" />
        @if (limitForm.get('limitation')?.hasError('required') && limitForm.get('limitation')?.touched) {
          <mat-error>Limit is required</mat-error>
        }
        @if (limitForm.get('limitation')?.hasError('min')) {
          <mat-error>Limit must be greater than or equal to 0</mat-error>
        }
      </mat-form-field>

      <!-- Priority -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>
          {{ 'BackOffice.ManageContracts.ContractLimit.Priority' | translate: locale.language }}
        </mat-label>
        <mat-select formControlName="priority" aria-label="Select priority (optional)">
          <mat-option [value]="''">None</mat-option>
          @for (priority of priorities; track priority.id) {
            <mat-option [value]="priority.id">
              {{ priority.value }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" [mat-dialog-close]="null" aria-label="Cancel and close dialog">
    {{ 'BackOffice.ManageContracts.ContractLimit.CloseButton' | translate: locale.language }}
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="formInValid()"
    [mat-dialog-close]="limitForm.getRawValue()"
    [attr.aria-label]="create ? 'Save new limit' : 'Save limit changes'">
    {{ 'BackOffice.ManageContracts.ContractLimit.SaveButton' | translate: locale.language }}
  </button>
</mat-dialog-actions>
